import { Image } from "antd-mobile";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import styles from "./style.module.scss";
import rejectedImage from "./images/rejected.png";
import { useGetCSLink } from "./hooks/rejected.hooks";

const ApplicationRejected = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const userCurrency = params.get("currency");

  const { data, isLoading, isError } = useGetCSLink({
    userCurrency: userCurrency,
    option: {
      enabled: userCurrency !== null,
    },
  });

  const onHandleCSCall = () => {
    if (!data) return;
    const csLinkValue = JSON.parse(data[0]?.value);
    window.location.href = csLinkValue.cs_url;
  };

  return (
    <div className={styles.container}>
      <Image height={121} fit={"contain"} src={rejectedImage} preview={false} />
      <div className={styles.title}>{t("apply.rejected")}</div>
      <div className={styles.subtitle}>{t("apply.rejectedSubtitle")}</div>
      {isLoading ? (
        ""
      ) : isError ? (
        ""
      ) : (
        <div onClick={onHandleCSCall} className={styles.button}>
          {t("apply.contactCs")}
        </div>
      )}
    </div>
  );
};

export default ApplicationRejected;
